import { render, staticRenderFns } from "./PreviewSelectedPurchaseInvoice.vue?vue&type=template&id=018c4ebd&scoped=true&"
import script from "./PreviewSelectedPurchaseInvoice.vue?vue&type=script&lang=js&"
export * from "./PreviewSelectedPurchaseInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018c4ebd",
  null
  
)

export default component.exports